import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c81184f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2c81184f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81184f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c81184f')) {
      api.createRecord('2c81184f', component.options)
    } else {
      api.reload('2c81184f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c81184f&scoped=true", function () {
      api.rerender('2c81184f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImChat/index.vue"
export default component.exports